import { createContext } from 'react';

const LocalizedContext = createContext('en');    // Default value, likely not used

export default LocalizedContext;